export default class RefreshTokenExpiredException extends Error {
  constructor(message: string) {
    super(message);
  }
}
